import { useEffect, useRef } from "react";

export function useIsMounted(): boolean {
    const isMounted = useRef<boolean>(true);

    useEffect(() => () => { isMounted.current = false }, []);

    return isMounted.current;
}